import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Process } from './components/Process';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { ConsultationForm } from './components/ConsultationForm';
import { AboutUs } from './pages/AboutUs';
import { Resources } from './pages/Resources';
import { ContactUs } from './pages/ContactUs';
import { TrademarkRegistration } from './pages/TrademarkRegistration';
import { TrademarkLandingPage } from './pages/TrademarkLandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsConditions } from './pages/TermsConditions';
import { ServiceTemplate } from './components/ServiceTemplate';
import { LogoShowcase } from './pages/LogoShowcase';

const Home = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  const openForm = () => {
    setIsFormOpen(true);
  };
  
  const closeForm = () => {
    setIsFormOpen(false);
  };
  
  return (
    <div>
      <Navbar onOpenForm={openForm} />
      <Hero onOpenForm={openForm} />
      <About />
      <Services onOpenForm={openForm} />
      <Pricing onOpenForm={openForm} />
      <Process onOpenForm={openForm} />
      <WhyChooseUs />
      <Testimonials />
      <CTA onOpenForm={openForm} />
      <Footer />
      <ConsultationForm 
        isOpen={isFormOpen} 
        onClose={closeForm}
        formType="consultation"
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lp" element={<TrademarkLandingPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/logos" element={<LogoShowcase />} />
          
          {/* Trademark Services */}
          <Route path="/services/trademark-search-registration" element={<TrademarkRegistration />} />
          <Route path="/services/trademark/clearance" element={<ServiceTemplate serviceKey="trademark-clearance" />} />
          <Route path="/services/trademark/application" element={<ServiceTemplate serviceKey="trademark-application" />} />
          <Route path="/services/trademark/office-actions" element={<ServiceTemplate serviceKey="trademark-office-actions" />} />
          <Route path="/services/trademark/monitoring" element={<ServiceTemplate serviceKey="trademark-monitoring" />} />
          <Route path="/services/trademark/statement-of-use" element={<ServiceTemplate serviceKey="trademark-statement-of-use" />} />
          <Route path="/services/trademark/ownership-change" element={<ServiceTemplate serviceKey="trademark-ownership-change" />} />
          <Route path="/services/trademark/portfolio" element={<ServiceTemplate serviceKey="trademark-portfolio" />} />
          
          {/* Copyright Services */}
          <Route path="/services/copyright/registration" element={<ServiceTemplate serviceKey="copyright-registration" />} />
          <Route path="/services/copyright/enforcement" element={<ServiceTemplate serviceKey="copyright-enforcement" />} />
          <Route path="/services/copyright/assignments" element={<ServiceTemplate serviceKey="copyright-assignments" />} />
          <Route path="/services/copyright/litigation" element={<ServiceTemplate serviceKey="copyright-litigation" />} />
          <Route path="/services/copyright/portfolio" element={<ServiceTemplate serviceKey="copyright-portfolio" />} />
          <Route path="/services/copyright/dmca" element={<ServiceTemplate serviceKey="copyright-dmca" />} />
          
          {/* Patent Services */}
          <Route path="/services/patent/searches" element={<ServiceTemplate serviceKey="patent-searches" />} />
          <Route path="/services/patent/office-actions" element={<ServiceTemplate serviceKey="patent-office-actions" />} />
          <Route path="/services/patent/applications" element={<ServiceTemplate serviceKey="patent-applications" />} />
          <Route path="/services/patent/enforcement" element={<ServiceTemplate serviceKey="patent-enforcement" />} />
          
          {/* Company Formation */}
          <Route path="/services/company/llc" element={<ServiceTemplate serviceKey="company-llc" />} />
          <Route path="/services/company/c-corp" element={<ServiceTemplate serviceKey="company-c-corp" />} />
          <Route path="/services/company/s-corp" element={<ServiceTemplate serviceKey="company-s-corp" />} />
          <Route path="/services/company/non-profit" element={<ServiceTemplate serviceKey="company-non-profit" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;